
import { toast } from "sonner";

interface FormData {
  name: string;
  ipAddress: string;
  description: string;
  primaryEmail: string;
  secondaryEmails: string[];
  imageUrls: string[];
  startDate: Date | undefined;
  endDate: Date | undefined;
}

export const validateProductForm = (formData: FormData): boolean => {
  const { name, ipAddress, primaryEmail, startDate, endDate } = formData;
  
  if (!name.trim()) {
    toast.error("Le nom du produit est requis");
    return false;
  }
  
  if (!ipAddress.trim()) {
    toast.error("L'adresse IP est requise");
    return false;
  }
  
  // Validation de l'adresse IP
  const ipRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
  if (!ipRegex.test(ipAddress)) {
    toast.error("L'adresse IP n'est pas valide");
    return false;
  }
  
  if (!primaryEmail.trim()) {
    toast.error("L'email principal est requis");
    return false;
  }
  
  // Validation de l'email principal
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(primaryEmail)) {
    toast.error("L'email principal n'est pas valide");
    return false;
  }
  
  // Validation des emails secondaires
  for (const email of formData.secondaryEmails) {
    if (!emailRegex.test(email)) {
      toast.error(`L'email secondaire "${email}" n'est pas valide`);
      return false;
    }
  }
  
  if (!startDate) {
    toast.error("La date de début de licence est requise");
    return false;
  }
  
  if (!endDate) {
    toast.error("La date d'expiration est requise");
    return false;
  }
  
  if (startDate >= endDate) {
    toast.error("La date d'expiration doit être postérieure à la date de début");
    return false;
  }
  
  return true;
};
